import type { Directive } from 'vue'
import { useUserStore } from '@/stores/user'

type PermissionValue = string | string[]

function check(value: PermissionValue): boolean {
  const userStore = useUserStore()
  return userStore.hasPermission(value)
}

/**
 * 按钮级权限：v-permission="'admin:user:edit'" / v-permission="['a','b']"
 */
export const permission: Directive<HTMLElement, PermissionValue> = {
  mounted(el, binding) {
    if (!binding.value) return
    if (!check(binding.value)) {
      el.parentNode?.removeChild(el)
    }
  },
  updated(el, binding) {
    if (!binding.value) return
    if (!check(binding.value)) {
      el.parentNode?.removeChild(el)
    }
  },
}

export default permission
